/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import React from 'react';
import PropTypes from 'prop-types';
import * as consts from '../../const';
import { Button, Form, Clearfix } from 'react-bootstrap';

class ParticipantHasNewVersionsModal extends React.Component {
  constructor(props) {
    super(props);
    this.openAddNewDocumentModal = this.openAddNewDocumentModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  closeModal() {
    this.props.closeModal();
  }

  openAddNewDocumentModal() {
    this.props.openAddNewDocumentModal();
  }

  render() {
    return (
      <div id="participant-has-new-versions-component">
        <p id="participant-has-new-versions-message">{consts.PARTICIPANT_HAS_NEW_VERSIONS_TO_SIGN_MESSAGE}</p>
        <div id="participant-new-versions-footer" className="participant-new-versions-footer">
          <hr id="participant-new-versions-footer-separator" />
          <Button id="participant-new-versions-continue-button" onClick={this.closeModal}>
            {consts.PARTICIPANT_CONTINUE_WITH_EXISTING_DOCUMENTS}
          </Button>
          <Button
            id="participant-new-versions-add-documents-button"
            bsStyle="primary"
            onClick={this.openAddNewDocumentModal}
          />
          {consts.I_NEED_TO_ADD_DOCUMENTS_TO_PARTICIPANT}
          <Clearfix />
        </div>
      </div>
    );
  }
}

ParticipantHasNewVersionsModal.propTypes = {
  closeModal: PropTypes.func,
  openAddDocumentsModal: PropTypes.func
};

export default ParticipantHasNewVersionsModal;
